<template>
  <div class="content">
    <!-- <base-header class="pb-6">
      <div class="row align-items-center py-2"></div>
    </base-header> -->
    <!-- <div class="dash-header mb-4">
        <h2 class="text-default m-0 d-flex">Companies <img data-v-2131a5ef="" src="/signup-img/fire.svg" alt=""></h2>
      </div> -->
    <div class="all-companies">
      <companies companyHeading=""></companies>
    </div>
  </div>
</template>
<script>
import Companies from "./Companies.vue";

export default {
  components: {
    Companies
  },
  data() {
    return {};
  },
  created: function() {},
  methods: {}
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
